// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1uXUC","approved":"Status_approved__lB4Dx","rejected":"Status_rejected__1YC4y","expired":"Status_expired__3wNWP","label":"Status_label__ICUU0"};